export function hasPackage(packageId) {
    const { set } = window.QD_ADMIN_COMMON?.data || {};
    const { current, available } = set || {};

    let hasPackageFlag = false;

    if (String(current) === String(packageId)) {
        hasPackageFlag = true;
    } else if (available && available.length) {
        hasPackageFlag = available.some(item => {
            const { id } = item || {};
            return String(id) === String(packageId);
        });
    }

    return hasPackageFlag;
}

export function hasPackages(packageIdArr) {
    const { set } = window.QD_ADMIN_COMMON?.data || {};
    const { current, available } = set || {};

    let hasPackageFlag = false;
    const availableMap = {};

    if (available && available.length > 0) {
        available.forEach(item => {
            const { id } = item || {};
            availableMap[String(id)] = 1;
        });
    }

    if (packageIdArr && packageIdArr.length > 0) {
        hasPackageFlag = packageIdArr.some(id => {
            return String(current) === String(id) || availableMap[String(id)];
        });
    }

    return hasPackageFlag;
}

export function isXtPackage(packageId) {
    if (window.QD_ADMIN_COMMON?.isXtPackage) { 
        return window.QD_ADMIN_COMMON.isXtPackage(packageId);
    }

    // 协同权限基底套餐
    const xtPackageMap = {
        10002: '商通基础版',
        10016: '企业QQ2.0',
        10013: '商通标准版',
        10037: '商通物流版',
        10055: '腾采通基础版',
        10056: '腾采通专业版',
        10059: '腾采通标准版'
    };
    return !!xtPackageMap[packageId];
}